module.exports = require('./helpers/bundle-url').getBundleURL('cGICz') + "6904.26c143d4.jpg";